export const CASES = [
  {
    slug: "lge-prime-plumbing",
    client: "LGE Prime Plumbing",
    category: "Website & Local SEO",
    location: "Plumbing · San Diego, CA",
    metric: "Clean. Professional. Guaranteed.",
    img: "/work/lge-prime-plumbing.jpg",
    url: "https://lgeprimeplumbing.com",
    testid: "case-study-card-1",
    summary:
      "A family-owned San Diego plumbing company since 2010, trusted for emergency repairs, water heaters, drains, and commercial work across the county.",
    challenge:
      "LGE Prime Plumbing had built its reputation on five-star service — but online, that reputation wasn't working hard enough. In a trade where the first call wins the job, showing up clean and professional on search matters as much as showing up at the door.",
    approach:
      "We rebuilt their web presence around how homeowners actually search in an emergency: a fast, trust-first website with one-tap calling, weekly SEO updates targeting San Diego service areas, and Google Ads managed weekly so every dollar chases booked jobs — not impressions.",
    results: [
      ["Website", "Rebuild with new SEO"],
      ["Local SEO", "Weekly updates"],
      ["Google Ads", "Weekly management"],
    ],
  },
  {
    slug: "alpha-structural",
    client: "Alpha Structural",
    category: "Google Ads & SEO",
    location: "Foundation & Structural · Los Angeles, CA",
    metric: "Fix it right. Fix it once.",
    img: "/work/alpha-structural.jpg",
    url: "https://www.alphastructural.com",
    testid: "case-study-card-2",
    summary:
      "Southern California's most trusted foundation repair and structural contractor — 30+ years, engineer-and-build, across Los Angeles, Orange County, Ventura, and Santa Barbara.",
    challenge:
      "Alpha Structural does the jobs other contractors are afraid of — hillside repairs, seismic retrofits, foundation replacement. But high-stakes work means long, research-heavy buying decisions, and being the best-kept secret in structural repair doesn't fill a pipeline.",
    approach:
      "We run always-on Google Ads managed weekly around high-intent structural searches, paired with an SEO and content engine that turns their engineering expertise — already famous on social — into search visibility across every service line and location they serve.",
    results: [
      ["Google Ads", "Weekly management"],
      ["SEO", "Content engine"],
      ["Content", "On-site filming"],
    ],
  },
  {
    slug: "point-loma-home-pros",
    client: "Point Loma Home Pros",
    category: "Web Development & SEO",
    location: "Home Services · San Diego, CA",
    metric: "Just one call — we handle it all.",
    img: "/work/point-loma-home-pros.webp",
    url: "https://pointlomahomepros.com",
    testid: "case-study-card-3",
    summary:
      "San Diego's neighborhood electricians, plumbers, and heating & air pros since 1988 — over 2,000 online reviews and a 4.9-star reputation.",
    challenge:
      "Four trades under one roof — HVAC, electrical, plumbing, and water filtration — means four times the search battleground. Point Loma Home Pros had the reviews and the history; they needed a digital presence that converted that trust into scheduled jobs across every service line.",
    approach:
      "A rebuilt website engineered around booking — online scheduling, one-tap calls, instant quotes — backed by weekly SEO updates across their San Diego service areas and weekly Google Ads management tuned to the jobs they want most.",
    results: [
      ["Website", "Rebuild with new SEO"],
      ["SEO", "Weekly updates"],
      ["Google Ads", "Weekly management"],
    ],
  },
  {
    slug: "sf-general-contractor",
    client: "Constructive Solutions",
    category: "Website & SEO",
    location: "Commercial Construction · San Francisco Bay Area",
    metric: "Building the Bay Area since 2010.",
    img: "/work/sf-general-contractor.jpg",
    url: "https://sanfranciscogeneralcontractor.com",
    testid: "case-study-card-4",
    summary:
      "A commercial general contractor behind some of the Bay Area's most iconic tenant improvements, seismic retrofits, renovations, and ground-up builds.",
    challenge:
      "Constructive Solutions wins work on reputation and relationships — but commercial clients research long before they call. Their digital presence needed to carry the same weight as their portfolio: iconic Bay Area projects, delivered on deadline.",
    approach:
      "We rebuilt their website to lead with the work — portfolio-first design, project storytelling, and clear paths to a consultation — supported by weekly SEO updates and local listings & citation setup so Bay Area decision-makers find them first.",
    results: [
      ["Website", "Rebuild with new SEO"],
      ["SEO", "Weekly updates"],
      ["Local", "Listings & citations"],
    ],
  },
];
